module.exports = __webpack_public_path__ + "static/tv70-7196f4249fdd12c29c177bbd123a786a.svg";